"use strict";

(function (globalFooter) {

  var AGENT_NOT_STARTED_OR_NOT_INSTALLED_TEMPLATE = '/components/agentNotStarted.html';  // Скомпилированные шаблоны не позволяют использовать функцию L


  var AgentNotStartedWidget = WA.components.dialogs.FloatDialog.extend({

    // Конструктор.
    init: function (args) {
      var me = this;
      me._super('agentNotStartedWidget', {
        showMinimizeButton: false,
        showCloseButton: false,
        minimized: true,
        hidden: true,
        title: L('WEBACCESS_AGENT_NAME'),
        loadingText: L('WAITING_AGENT_TEXT')
      });

      me.bind(me['class'].EVENT.AFTER_CLOSE, function () {
        WA.cache.setItem("agent.dontShowAgentNotStartedWidget", "1");
      });

      // Инициализировать обработку событий обновления.
      me._initUpdateHandling();
    },

    _createHtml: function () {
      var me = this;

      me._super();

      //// Когда отрендерятся шаблон, создаем из них DOM элементы.
      //$.when(WA.templates.render(AGENT_NOT_STARTED_OR_NOT_INSTALLED_TEMPLATE)).done(function (agentNotStartedMessage) {
      //  me.setContentAsHtml(agentNotStartedMessage, function () {
      //    me._jContent.find('.agent-not-started__button_start').on('click', function () {
      //      me.onStart();
      //      return false;
      //    });
      //    me._jContent.find('.agent-not-started__button_download').on('click', function () {
      //      me.onDownload();
      //      return false;
      //    });
      //  });
      //});
    },

    show: function () {
      // Не показываем диалог, если пользователь его уже закрывал.
      this._super();
    },

    onStart: function () {
      var me = this;

      // Сворачиваем виджет и пишем «Запуск агента…»
      me.setMinimized(true);
      me.setTitle(L('AGENT_WAITING_START'));

      log.info('AGENT', 'Agent starting by URL scheme...');
      Core.agent.start().done(function () {
        log.info('AGENT', 'Agent started');
        me.fire(me['class'].EVENT.AFTER_START);
      }).fail(function (err) {
        me.setMinimized(false);
        me.setTitle(L('WEBACCESS_AGENT_NAME'));
        me.setContent(err);
      });
    },

    onDownload: function () {
      var me = this;
      log.info('AGENT', 'Agent downloading...');
      WA.agent.download().done(function (platform) {
        me.fire(me['class'].EVENT.AFTER_DOWNLOAD, platform);
      }).fail(function () {
        me.fire(me['class'].EVENT.AFTER_DOWNLOAD, null);
      });
    },

    // Обработка событий обновления агента.
    _initUpdateHandling: function () {
      var me = this;
      Core.agent.beforeUpdating(function () { me._beforeUpdating(); });
      Core.agent.onUpdating(function (progress) { me._onUpdating(progress); });
      Core.agent.afterUpdating(function () { me._afterUpdating(); });
      Core.agent.onFailUpdating(function () { me._onFailUpdating(); });
      Core.agent.afterUpdatingRestarted(() => {
        this._afterUpdatingRestarted();
      });

      log.info('AGENT', 'Agent updating handlers was initalized');
    },

    // До начала процесса обновления.
    _beforeUpdating: function () {
      var me = this;
      me.show();
      me.setMinimized(false);
      log.info('AGENT', 'Agent before updating was triggered');
      me.setTitle(L('WEBACCESS_AGENT_NAME'));
      me.showLoader(L('AGENT_IS_BEING_UPDATED'));
    },
    // В процессе обновления.
    _onUpdating: function (progress) {
      log.info("AGENT", "Agent updating: " + progress.timeStamp);
    },
    // После обновления.
    _afterUpdating() {
      this.showLoader(L('AGENT_IS_BEING_RESTARTED'));
    },
    // Если обновление завершилось с ошибкой.
    _onFailUpdating: function () {
      var me = this;
      me.setMinimized(false);
      me.setTitle(L('WEBACCESS_AGENT_NAME'));
      me.setContent(L("AGENT_UPDATING_WAS_FAILED"));
    },
    // После обновления и перезапуска.
    _afterUpdatingRestarted() {
      this.setMinimized(true);
      this.hide();
    },
    // Отключить обработчики событий обновления агента.
    _unbindUpdateHandlers: function () {
      var me = this;
      Core.agent.unbind(Core.agent.EVENT.BEFORE_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.ON_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.AFTER_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.ON_FAIL_UPDATING);
      Core.agent.unbind(Core.agent.EVENT.AFTER_UPDATING_RESTARTED);
    }

  }, {
    EVENT: $.extend({
      // Событие срабатывает после старта агента.
      AFTER_START: 'start',

      // Событие срабатывает после скачивания агента.
      AFTER_DOWNLOAD: 'download'
    }, WA.CMP.dialogs.FloatDialog.EVENT)
  });




  // ---------------------------------------------------------------------------------------------------
  //                                          Public functions
  // ---------------------------------------------------------------------------------------------------
  var agentNotStartedWidget = new AgentNotStartedWidget()
  globalFooter.agentNotStartedWidget = agentNotStartedWidget;

})(window.Core.footer);